var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPianostudisvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 28,
    viewBox: "0 0 53 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52.5,
    height: 27.5,
    fill: "#F47140"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1479 21.5602C25.5324 21.5402 25.8979 21.3862 26.1814 21.1248L39.0794 9.18043C39.2389 9.03202 39.3677 8.85354 39.4584 8.6552C39.5491 8.45686 39.6 8.24252 39.6082 8.02444C39.6164 7.80636 39.5817 7.5888 39.506 7.38418C39.4304 7.17957 39.3153 6.9919 39.1673 6.83191C39.0194 6.67191 38.8415 6.54272 38.6438 6.45171C38.4461 6.36069 38.2324 6.30964 38.015 6.30146C37.7976 6.29328 37.5808 6.32814 37.3768 6.40405C37.1729 6.47995 36.9858 6.59542 36.8264 6.74385L25.0549 17.641L13.2833 6.74385C13.1239 6.59542 12.9368 6.47995 12.7329 6.40405C12.5289 6.32814 12.3121 6.29328 12.0947 6.30146C11.8773 6.30964 11.6637 6.36069 11.466 6.4517C11.2682 6.54272 11.0903 6.67191 10.9424 6.83191C10.7944 6.9919 10.6794 7.17957 10.6037 7.38418C10.5281 7.5888 10.4933 7.80636 10.5015 8.02444C10.5097 8.24252 10.5606 8.45685 10.6513 8.6552C10.7421 8.85354 10.8708 9.03202 11.0303 9.18043L23.9284 21.1248C24.092 21.2759 24.2843 21.3923 24.4939 21.4672C24.7034 21.542 24.9259 21.5736 25.1479 21.5602Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPianostudisvg);
export default __webpack_public_path__ + "static/media/pianostudisvg.7f7162e9ff50dd0df40eb7a026eedd6b.svg";
export { ForwardRef as ReactComponent };